import React, { useState, useRef } from 'react';

// Tag filter with a search box: type to narrow the tag list, click a tag or
// press Enter to add the first match. "Browse all" still opens the full list.
// Used by Subreddits and the Scheduler's "Add individual subreddit" picker.

// "big tits", "Big_Tits" and "bigtits" all find "big-tits"
const norm = (s) => String(s).toLowerCase().replace(/[\s_-]+/g, '');

function TagFilter({ tags, selected, onChange, compact = false }) {
  const [query, setQuery] = useState('');
  const [browse, setBrowse] = useState(false);
  const inputRef = useRef(null);

  const q = norm(query.trim());
  // Tags that start with the query come before tags that only contain it
  const matches = q
    ? tags.filter(t => norm(t).includes(q))
        .sort((a, b) => (norm(b).startsWith(q) - norm(a).startsWith(q)) || a.localeCompare(b))
    : tags;
  const showList = q !== '' || browse;

  const toggle = (tag) => {
    onChange(selected.includes(tag) ? selected.filter(t => t !== tag) : [...selected, tag]);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const first = matches.find(t => !selected.includes(t));
      if (q && first) { onChange([...selected, first]); setQuery(''); }
    } else if (e.key === 'Escape' && query) {
      e.stopPropagation();
      setQuery('');
    }
  };

  const chip = compact
    ? { padding: '3px 10px', borderRadius: '14px', fontSize: '11px' }
    : { padding: '5px 14px', borderRadius: '16px', fontSize: '13px' };

  return (
    <div style={{ marginBottom: compact ? '10px' : '12px' }}>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap', marginBottom: showList ? '8px' : '0' }}>
        <input
          ref={inputRef}
          placeholder={`🏷️ Search ${tags.length} tags…`}
          value={query}
          onChange={e => setQuery(e.target.value)}
          onKeyDown={onKeyDown}
          style={{ flex: '0 1 240px', minWidth: '160px', fontSize: compact ? '12px' : '13px', padding: compact ? '6px 10px' : '7px 12px' }}
        />
        <button
          onClick={() => { setBrowse(!browse); inputRef.current?.focus(); }}
          className="btn-secondary"
          style={{ fontSize: compact ? '11px' : '12px', padding: compact ? '4px 10px' : '6px 12px', whiteSpace: 'nowrap' }}
        >
          Browse all {browse ? '▲' : '▼'}
        </button>
        {selected.length > 0 && (
          <button
            onClick={() => onChange([])}
            className="btn-secondary"
            style={{ fontSize: '10px', padding: '3px 8px', color: '#ef4444', borderColor: '#7f1d1d', whiteSpace: 'nowrap' }}
          >Clear all</button>
        )}
        {selected.map(t => (
          <span key={t} onClick={() => toggle(t)} title="Remove" style={{
            padding: '2px 8px', borderRadius: '10px', fontSize: compact ? '10px' : '11px', cursor: 'pointer',
            background: '#ff4500', color: '#fff', border: '1px solid #ff4500'
          }}>{t} ×</span>
        ))}
      </div>
      {showList && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: compact ? '5px' : '6px', maxHeight: compact ? '120px' : '200px', overflowY: 'auto', padding: '8px', background: '#0f0f0f', borderRadius: '8px', border: '1px solid #2a2a2a' }}>
          {matches.length === 0 ? (
            <span style={{ fontSize: '12px', color: '#555' }}>No tags match “{query.trim()}”</span>
          ) : matches.map(tag => {
            const on = selected.includes(tag);
            return (
              <span key={tag} onClick={() => toggle(tag)} style={{
                ...chip, cursor: 'pointer', userSelect: 'none',
                background: on ? '#ff4500' : '#2a2a2a', color: on ? '#ffffff' : '#aaaaaa',
                border: on ? '1px solid #ff4500' : '1px solid #444'
              }}>{tag}</span>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default TagFilter;
